/* FR Makeover – Burger-Menü DESKTOP (snippets/fr-menu-desktop.liquid)
   1) Reiter der Themen-Leiste (Klick + Pfeiltasten, wie ein Tablist)
   2) Markenschalter bei „Nach Produktart“: wechselt Bildebene + Link je Kachel,
      teilt sich die Wahl mit dem mobilen Menü (sessionStorage „frMenuBrand“). */
(function () {
  function init() {
    var root = document.querySelector('[data-frd]');
    if (!root || root.__frdReady) return;
    root.__frdReady = true;

    /* ---------- 1) Reiter ---------- */
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-frd-tab]'));
    function select(id, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-frd-tab') === id;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      root.querySelectorAll('[data-frd-panel]').forEach(function (p) {
        var on = p.getAttribute('data-frd-panel') === id;
        if (on && p.hidden) {
          p.hidden = false;
          p.classList.remove('is-entering');
          void p.offsetWidth; /* Animation neu starten */
          p.classList.add('is-entering');
        } else if (!on) {
          p.hidden = true;
        }
      });
      if (window.FRT && FRT.track) { try { FRT.track('d-tab-' + id); } catch (e) {} }
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t.getAttribute('data-frd-tab'), false); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowDown') n = tabs[(i + 1) % tabs.length];
        else if (k === 'ArrowUp') n = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (k === 'Home') n = tabs[0];
        else if (k === 'End') n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); select(n.getAttribute('data-frd-tab'), true); }
      });
    });

    /* Beim Öffnen des Menüs immer mit „Nach Produktart“ starten */
    var drawer = document.getElementById('sidebar-menu');
    if (drawer && tabs.length) {
      new MutationObserver(function () {
        if (drawer.getAttribute('aria-hidden') === 'false') select(tabs[0].getAttribute('data-frd-tab'), false);
      }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
    }

    /* ---------- 2) Markenschalter ---------- */
    var box = root.querySelector('[data-frd-panel="produktart"]');
    if (!box) return;
    function apply(brand) {
      if (brand !== 'a' && brand !== 'b') brand = 'all';
      box.setAttribute('data-fr-brand', brand);
      box.querySelectorAll('[data-frd-seg]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-frd-seg') === brand ? 'true' : 'false');
      });
      box.querySelectorAll('.frD__Tile--pa').forEach(function (t) {
        var href = t.getAttribute('data-href-' + brand);
        if (href) t.setAttribute('href', href);
        var n = brand === 'all' ? '1' : (t.getAttribute('data-n-' + brand) || '0');
        t.classList.toggle('is-empty', n === '0');
        if (n === '0') t.setAttribute('aria-disabled', 'true'); else t.removeAttribute('aria-disabled');
      });
      try { sessionStorage.setItem('frMenuBrand', brand); } catch (e) {}
    }
    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-frd-seg]');
      if (b) apply(b.getAttribute('data-frd-seg'));
    });
    var saved = '';
    try { saved = sessionStorage.getItem('frMenuBrand') || ''; } catch (e) {}
    if (saved === 'a' || saved === 'b') apply(saved);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  /* Theme-Editor: nach dem Ändern von Bildern wird die Sektion neu geladen */
  document.addEventListener('shopify:section:load', init);
})();
